import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awards-examples',
  templateUrl: './awards-examples.component.html',
  styleUrls: ['./awards-examples.component.scss']
})
export class AwardsExamplesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
